import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { BOOKINGS_URL } from "./api-url.constants";

export const deleteBooking = async (id: string): Promise<void> => {
  await typedFetch(`${BOOKINGS_URL}/${id}`, {
    method: API_METHODS.DELETE,
  });
};
